/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 *
 * @export
 * @enum {string}
 */
const TranscodeReason = {
    ContainerNotSupported: 'ContainerNotSupported',
    VideoCodecNotSupported: 'VideoCodecNotSupported',
    AudioCodecNotSupported: 'AudioCodecNotSupported',
    SubtitleCodecNotSupported: 'SubtitleCodecNotSupported',
    AudioIsExternal: 'AudioIsExternal',
    SecondaryAudioNotSupported: 'SecondaryAudioNotSupported',
    VideoProfileNotSupported: 'VideoProfileNotSupported',
    VideoLevelNotSupported: 'VideoLevelNotSupported',
    VideoResolutionNotSupported: 'VideoResolutionNotSupported',
    VideoBitDepthNotSupported: 'VideoBitDepthNotSupported',
    VideoFramerateNotSupported: 'VideoFramerateNotSupported',
    RefFramesNotSupported: 'RefFramesNotSupported',
    AnamorphicVideoNotSupported: 'AnamorphicVideoNotSupported',
    InterlacedVideoNotSupported: 'InterlacedVideoNotSupported',
    AudioChannelsNotSupported: 'AudioChannelsNotSupported',
    AudioProfileNotSupported: 'AudioProfileNotSupported',
    AudioSampleRateNotSupported: 'AudioSampleRateNotSupported',
    AudioBitDepthNotSupported: 'AudioBitDepthNotSupported',
    ContainerBitrateExceedsLimit: 'ContainerBitrateExceedsLimit',
    VideoBitrateNotSupported: 'VideoBitrateNotSupported',
    AudioBitrateNotSupported: 'AudioBitrateNotSupported',
    UnknownVideoStreamInfo: 'UnknownVideoStreamInfo',
    UnknownAudioStreamInfo: 'UnknownAudioStreamInfo',
    DirectPlayError: 'DirectPlayError',
    VideoRangeTypeNotSupported: 'VideoRangeTypeNotSupported',
    VideoCodecTagNotSupported: 'VideoCodecTagNotSupported'
};

export { TranscodeReason };
